import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-demo-onboarding',
  standalone: false,
  templateUrl: './modal-demo-onboarding.component.html',
  styleUrl: './modal-demo-onboarding.component.scss'
})
export class ModalDemoOnboardingComponent {
  className = 'modal-demo-onboarding';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalDemoOnboardingComponent>
  ) {}
  close() {
    this.dialogRef.close({ action: 'close' });
  }
  openOnboarding() {
    this.dialogRef.close({ action: 'open-onboarding' });
  }
}